var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.theme,attrs:{"id":"app"}},[_c('Header'),_c('router-view',{key:_vm.$route.path}),_c('Newsletter'),_c('TreineBanners',{attrs:{"area":"footer"}}),_c('TreineBanners',{attrs:{"area":"subfooter"}}),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }